import { DailyReward } from "@onmo/ui";
import { useQuery } from "@apollo/client";
import { Query } from "@onmo/graphql/graphql";
import { recentlyPlayedGamesGQL } from "../../graphql";
import { loginGQL, useLegacyMutation } from "@onmo/graphql/legacyGraphql";
import MainHeader from "../../components/common/MainHeader/MainHeader";
import { BannerSlides } from "../../components/common/BannerSlides";
import { ContinuePlay } from "../../components/common/ContinuePlay";
import { GamesCategory } from "../../components/common/GamesCategory";
import { useStyles } from "./Homepage.style";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { addPopupQueue, removePopupQueue } from "../../slices/popup";
import { PopupType } from "../../constants/popup";
import { useFetchGames } from "../../hooks/useFetchGames";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AutoPreviewProvider } from "../../components/common/AutoPreviewProvider/AutoPreviewContext";

const Homepage: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { currentPopupId } = useAppSelector((state) => state.popup);
  const { theme } = useAppSelector((state) => state.theme);
  const { data: recentlyGameData } = useQuery<Query>(recentlyPlayedGamesGQL, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });
  const { gamesCategory, getListGameByCategory } = useFetchGames();
  const [iframeUrl, setIframeUrl] = useState("");
  const [login] = useLegacyMutation(loginGQL);

  const onBackAction = () => {
    setIframeUrl("");
    if (window && theme?.jsInterfaceName) {
      const jsInterface = (window as any)["jsInterface"];
      const viInterface = window[theme?.jsInterfaceName as any];
      if (jsInterface) {
        console.log("Inside jsInterface ", jsInterface);
        jsInterface.exec("myooredoolp", "back");
      } else if (viInterface) {
        console.log("Using VI jsInterface");
        viInterface.postMessage("back");
      } else {
        console.log("No jsInterface found");
        // this.location.back();
      }
    }
  };

  return (
    <div className={classes.root}>
      <MainHeader onClickBack={onBackAction} />
      <div className={classes.content}>
        <BannerSlides setIframeUrl={setIframeUrl} />
        {iframeUrl && (
          <iframe
            id="feature-item-iframe"
            title="feature-item-iframe"
            src={iframeUrl}
            className={classes.featureIframe}
          ></iframe>
        )}
        <ContinuePlay
          label={t("continue_play")}
          games={recentlyGameData?.me.recentlyPlayedGames}
          className={classes.continuePlay}
        />
        <AutoPreviewProvider>
          {/* <EarnGemBanner className={classes.earnGemBanner} /> */}
          {gamesCategory.map((category, index) => (
            <>
              <GamesCategory
                title={category}
                games={getListGameByCategory(category)}
              />
              {index === 0 && (
                <ContinuePlay
                  isTopGame
                  label={t("top_10_games")}
                  games={getListGameByCategory("Top 10")}
                  className={classes.continuePlay}
                />
              )}
            </>
          ))}
        </AutoPreviewProvider>
        <DailyReward
          open={currentPopupId === PopupType.DailyReward}
          onClosePopup={() =>
            dispatch(removePopupQueue({ type: PopupType.DailyReward }))
          }
          onOpenPopup={() =>
            dispatch(addPopupQueue({ type: PopupType.DailyReward }))
          }
          loginAction={login}
          className={classes.dailyReward}
        />
      </div>
    </div>
  );
};
export default Homepage;
